import { render, staticRenderFns } from "./SamSelectList.vue?vue&type=template&id=118b1956&scoped=true&shadow"
import script from "./SamSelectList.vue?vue&type=script&lang=js&shadow"
export * from "./SamSelectList.vue?vue&type=script&lang=js&shadow"
function injectStyles (context) {
  
  var style0 = require("./SamSelectList.vue?vue&type=style&index=0&id=118b1956&prod&scoped=true&lang=scss&shadow")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "118b1956",
  null
  ,true
)

export default component.exports